import React, { useState } from 'react';
import CTooltip from "react-tooltip-lite";
import {
    Card,
    CardBody,
    CardTitle,
    Col,
    Row,
    CardHeader,
    Button,
    Nav,
    NavItem,
    NavLink,
} from 'reactstrap';
import DownloadCSVButton from './DownlaodCSV';
import ErrorBoundary from 'components/ErrorBoundary';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
} from 'chart.js';
import { Line } from 'react-chartjs-2';
import { color, index } from 'd3';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
);

ChartJS.register(ArcElement, Tooltip, Legend);

const plugin = {
    beforeInit(chart) {
        // Get reference to the original fit function
        const originalFit = chart.legend.fit;

        // Override the fit function
        chart.legend.fit = function fit() {
            // Call original function and bind scope in order to use `this` correctly inside it
            originalFit.bind(chart.legend)();
            // Change the height as suggested in another answers
            this.height = this.height + 15;
        };
    },
};

export const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            ticks: {
                color: "#000",
                size: 15,
            },
        },
        y: {
            border: {
                display: false,
            },
        },
    },
    plugins: {

        legend: {

            backgroundPlugin: {
                color: 'rgba(0, 0, 0, 0)' // fully transparent
            }
            ,
            position: "top",
            labels: {
                padding: 15,
                usePointStyle: true,
                pointStyle: "rect",
                color: "#707070",
                font: {
                    size: 14,
                    weight: "600",
                },
            },
            align: "start",
        },
    },
};

const CapturedvsReplenished = ({ months, capture, replenished }) => {
    const copyData = {
        labels: months,
        datasets: [
            {
                label: "Captured",
                data: capture,
                borderColor: "#702C62",
                backgroundColor: "#702C62",
                pointRadius: 4.5,
            },
            {
                label: "Replenished",
                data: replenished,
                borderColor: "#3C363B",
                backgroundColor: "#3C363B",
                pointRadius: 4.5,
            },
        ],
    };



    return (
        <ErrorBoundary>



            <Card className="p-3 h-100 border-1 ">
                <CardHeader className="border-0 bg-white px-0 pt-0" style={{ paddingBottom: "0px" }}>
                    <Row className='align-items-center'>

                        <Col >
                            <CTooltip
                                content={
                                    <div className="tip-list-info">
                                        <p>
                                            The number of claims that captured and replenished by month.
                                        </p>
                                    </div>
                                }
                            >
                                <CardTitle className="f-20 font-weight-600 dashboard-headings">
                                    <div className="d-flex justify-content-between align-items-center top_left_hed pb-1">

                                        Captured vs Replenished
                                        <DownloadCSVButton
                                            monthsdata={months}
                                            valuedata1={capture}
                                            valuedata2={replenished}
                                            heading1={["Month", "Captured", "Replenished"]}
                                            filenamedata={"CapturedvsReplenished"}
                                        />
                                    </div>
                                </CardTitle>
                            </CTooltip>

                        </Col>

                    </Row>
                </CardHeader>
                <CardBody className='dashboard-chart-body'>
                    <Line options={options} data={copyData} plugins={[plugin]} />
                </CardBody>
            </Card>
        </ErrorBoundary>
    );
};

export default CapturedvsReplenished;
